import { useEffect, useState } from "react";
import {
  type LayoutMode,
  phoneMediaQuery,
  tabletShellMediaQuery,
} from "../constants/layoutBreakpoints";
import { compactShellMediaQuery } from "../constants/mobileBreakpoint";

function canUseMatchMedia(): boolean {
  return (
    typeof window !== "undefined" && typeof window.matchMedia === "function"
  );
}

function resolveLayoutMode(): LayoutMode {
  if (!canUseMatchMedia()) {
    return "desktop";
  }
  if (window.matchMedia(phoneMediaQuery).matches) {
    return "phone";
  }
  if (window.matchMedia(tabletShellMediaQuery).matches) {
    return "tablet";
  }
  return "desktop";
}

/**
 * Shell layout mode: phone (compact), tablet (desktop structure + touch density), desktop.
 */
export function useLayoutMode(): LayoutMode {
  const [mode, setMode] = useState<LayoutMode>(resolveLayoutMode);

  useEffect(() => {
    if (!canUseMatchMedia()) {
      return;
    }
    const queries = [
      window.matchMedia(phoneMediaQuery),
      window.matchMedia(tabletShellMediaQuery),
      window.matchMedia(compactShellMediaQuery),
    ];
    const onChange = () => setMode(resolveLayoutMode());
    onChange();
    for (const mq of queries) {
      mq.addEventListener("change", onChange);
    }
    return () => {
      for (const mq of queries) {
        mq.removeEventListener("change", onChange);
      }
    };
  }, []);

  return mode;
}
